export default __webpack_public_path__ + "static/media/outlook.6e2aeef9.png";